import {
  IOrder,
  IOrderData,
  OrderStatus,
  IRequestService,
  IRequestTravel,
  RequestTravel,
  IRequestServiceData,
  RequestService, IRequestItem, IRequestPromoCode, RequestPromoCode
} from './index'
import {
  Category,
  Customer, IContact,
  ICustomer,
  IDate
} from '../../index'

export class Order implements IOrder {
  readonly id: number
  readonly customer: ICustomer
  readonly category?: Category
  readonly token: string
  readonly total: number
  status: OrderStatus
  readonly recipient?: ICustomer
  request_travel?: IRequestTravel
  request_service?: IRequestService[]
  readonly promo_code?: IRequestPromoCode
  receipt?: string
  solution_name?: string
  date_creation?: IDate
  readonly stripe_product?: string
  readonly stripe_price?: string

  constructor(data: IOrderData) {
    this.id = data.id
    this.customer = new Customer(data.customer)
    this.category = data.category
    this.token = data.token
    this.total = data.total
    this.status = data.status || 'new'
    this.date_creation = data.date_creation
    this.receipt = data.receipt

    // solution fields
    this.solution_name = data.solution_name
    this.stripe_product = data.stripe_product
    this.stripe_price = data.stripe_price

    // certificate recipient
    let recipient = data.recipient
    this.recipient = recipient ? new Customer(recipient) : undefined

    // order items
    let travel = data.request_travel
    this.request_travel = travel ? new RequestTravel(travel) : undefined

    let services = data.request_service
    this.request_service = services ? services?.map((service: IRequestServiceData) => new RequestService(service)) : []

    let promo = data.promo_code
    this.promo_code = promo ? new RequestPromoCode(promo) : undefined

  }

  validate(): boolean {
    return true
  }

  update(data?: IOrderData): void {
    this.solution_name = data?.solution_name || this.solution_name
    this.status = data?.status || this.status;
    let travel = data?.request_travel
    if (travel) {
      this.request_travel?.update(travel)
    }
    data?.request_service?.forEach((item: IRequestServiceData) => {
      let services = this.request_service
      let service = services?.find((i: IRequestService) => i.id === item.id)
      if (service) {
        service.update(item)
      } else {
        services = services || [];
        services.push(new RequestService(item))
      }
    });
  }

}
